function initMap(uluru, contentString) {
    // Styles a map in night mode.
    var map = new google.maps.Map(document.getElementById('map'), {
        center: uluru,
        zoom: 16,
        styles: mapStyles
    });

    var marker = new google.maps.Marker({
        position: uluru,
        map: map,
        icon: 'https://sanus.cz/www/images/marker.svg',
        label:
            {
                color: '#00aaff',
                fontWeight: 'bold',
                fontSize: '14px',
                padding: '10px',
                marginLeft: '50px',
                text: ' '
            }
    });

    var infowindow = new google.maps.InfoWindow({
        content: contentString
    });

    infowindow.open(map, marker);
}

$(function() {
    var contactMap = $('.app-contact-map');

    if (contactMap.length > 0) {
        initMap({
            lat: contactMap.data('lat'),
            lng: contactMap.data('lng')
        }, contactMap.data('address'));
    }
});
